import Vue from 'vue';
import Vuex from 'vuex';
import information from '@/store/information';
import playerConsentFormStore from './playerConsentFormStore';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        information,
        playerConsentFormStore,
    },
});
